<style scoped lang="less">
.search {
  width: 90%;
  margin: 0 auto;
  padding-top: 0.5rem;
  border-bottom: 1px solid rgb(32, 165, 162);
  /deep/.van-search {
    padding: 3px 0px;
    box-sizing: border-box;
  }
  /deep/.van-search__content {
    background-color: #fff;
  }
  /deep/.van-icon-search::before {
    color: rgb(32, 165, 162);
    font-size: 1.3rem;
  }
  /deep/.van-search__content {
    padding-left: 0px;
  }
  /deep/.van-field__body {
    /* Safari，Chrome WebKit browsers */
    .van-field__control::-webkit-input-placeholder {
      color: rgb(32, 165, 162) !important;
    }
    /* 火狐 Mozilla Firefox 4 to 18 */
    .van-field__control:-moz-placeholder {
      color: rgb(32, 165, 162) !important;
    }
    /* 火狐 Mozilla Firefox 19+ */
    .van-field__control::-moz-placeholder {
      color: rgb(32, 165, 162) !important;
    }
    /* Internet Explorer 10+ */
    .van-field__control:-ms-input-placeholder {
      color: rgb(32, 165, 162) !important;
    }
    .van-field__control{
      color: rgb(32, 165, 162) !important;
    }
  }
}
/deep/.van-field__clear{
  color: rgba(255,255,255,0);
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  background-image: url('../assets/image/homePage/clear.png');
  background-size: 100% 100%;
  box-sizing: border-box;
  width:12px;
  height:15px;
  margin-left: 10px;
  // border:1px solid red;  
}
</style>
<template>
    <div class="search" v-if="!isRouter">
        <van-search v-model="search" @input="onSearch" @search="onSearch" :placeholder="placeholder">
          <template #action>
            <div>搜索</div>
          </template>
        </van-search>
    </div>
    <router-link v-else class="search" tag="div" :to="{path: '/lineList'}">
        <van-search v-model="search" @input="onSearch" @search="onSearch" :placeholder="placeholder">
          <!-- <template #action>
            <div>搜索</div>
          </template> -->
        </van-search>
    </router-link>
    
</template>
<script>
export default {
    props:{
        isRouter: {
          type: Boolean,
          default: false
        },
        searchVal:{
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
    },
  watch:{
    // search:(i)=>{
        
    // },
  },
  data() {
    return {
        search:""
    };
  },
  methods: {
      onSearch(i){
          this.$emit("onSearch",i)
      }
  },
  watch(){
    this.searchVal
  },
  watch:{
    searchVal(to,from){
      this.search = this.searchVal;
    }
  },
  mounted() {
    this.search = this.searchVal;
  },
};
</script>